module.exports = __webpack_public_path__ + "6794db0115fe57ff032c2bc4d2fec757.woff";